import React from 'react';
import CgPageLoader from 'modules/Common/layout/CgPageLoader';
import { useBranding } from '../hooks/useBranding';
import defaultLogo from 'assets/icons/logo.png';

export const DashboardLayout = ({ children, graph = false, loading = false }) => {
  const brand = useBranding();

  // While loading, render the same full-screen branded loader as the initial
  // app-open phase (InitPage) so the auth→page-data handoff reads as one
  // continuous screen instead of a second, differently-styled loader. Skip the
  // content padding here — the loader manages its own full-viewport layout.
  if (loading) {
    return (
      <CgPageLoader
        variant="fullscreen"
        logo={brand.logoUrl || defaultLogo}
        brandName={brand.name}
        primaryColor={brand.primaryColor}
      />
    );
  }

  return <div className={`${graph ? '' : 'px-6 pt-8 pb-10'}`}>{children}</div>;
};
